import React from "react";
import styles from "./RsvpGuestJoinLive.module.css";
import { Col, Layout, Row } from "antd";
import Header from "../../../../components/header/Header";
import bgcImage from "../../../../assets/bgcimage.png";
import bgcImage1 from "../../../../assets/bgcimage1.png";
import Rsvp from "../../../../assets/rsvp1.png";
import TextComponent from "../../../../components/textComponent/TextComponent";
import SubmitBotton from "../../../../components/submitButton/SubmitButton";
import { InputField, SubmitButton } from "../../../../components";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import Image1 from "../../../../assets/vendorimg6.png";
import Image2 from "../../../../assets/vendorimg7.png";
import dummy from "../../../../assets/dummy.jpg";
import Image4 from "../../../../assets/vendorimg7.png";
import { useState } from "react";
import Modal from "../../../../components/modal/Modal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";

const RsvpGuestJoinLive = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const rsvpData = useSelector(
    (state) => state?.GuestReducer?.guestRsvpDetails
  );
  const myStyle = {
    backgroundImage: `url(${bgcImage})`,
    backgroundRepeat: "no-repeat",
  };
  const myStyle1 = {
    backgroundImage: `url(${bgcImage1})`,
    backgroundRepeat: "no-repeat",
  };
  const arr = [
    {
      image: rsvpData?.groom_image ? rsvpData?.groom_image : dummy,
    },
    {
      image: rsvpData?.bride_image ? rsvpData?.bride_image : dummy,
    },
  ];

  const onJoinStream = () => {
    console.log('rsvpData',rsvpData)
    
    let eventData = {
      event_id: rsvpData?.event?.id,
    };
    dispatch(EventMiddleware.joinStrean(eventData))
      .then(data => {
        setIsModalVisible(false);
        navigate("/events/eventDetail/liveStream", {
          state: {
            data,
          },
        })
      })
      .catch(err => console.log(err));
  };

  return (
    <div style={myStyle} className={styles.mainContainer}>
      <Header
        mainHeader={styles.headerColor}
        isProfile={true}
        title={"RSVP"}
        style={{ padding: 0, background: "var(--white-color)", height: 85 }}
        onBackClick={() => navigate(-1)}
      />

      <div style={myStyle1} className={styles.mainDiv}>
        <div className={styles.innerContainer}>
          {arr.map((item) => {
            return (
              <div className={styles.innerRowContainer}>
                <img src={item?.image} className={styles.image1} />
              </div>
            );
          })}
        </div>
        <TextComponent
          text={"Dear Friends and Family,"}
          textClass={styles.text}
        />
        <TextComponent text={rsvpData?.our_story} textClass={styles.text2} />
        {/* <TextComponent
          text={" www.examplelivestream.com/jamesandlucywedding"}
          textClass={styles.text5}
        /> */}
        <Row className={styles.row}>
          <TextComponent textClass={styles.text3} text="Join Live Stream" />
          <svg
            onClick={() => setIsModalVisible(true)}
            className={styles.svg}
            viewBox="0 0 68 69"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_di_1_3950)">
              <circle
                cx="33.9932"
                cy="30.8457"
                r="30"
                fill="var(--primary-color)"
              />
            </g>
            <path
              d="M46.4255 37.1384C46.4255 37.8378 46.439 38.2541 46.4222 38.6704C46.3598 40.2158 45.2879 41.3535 43.7509 41.3619C38.3562 41.3888 32.9631 41.3872 27.5683 41.3652C25.9875 41.3585 24.865 40.2209 24.8532 38.6333C24.8263 35.0671 24.8263 31.501 24.8532 27.9348C24.865 26.3489 25.9891 25.213 27.57 25.2062C32.9361 25.1843 38.3022 25.186 43.6683 25.2062C45.2947 25.213 46.38 26.3489 46.4255 27.987C46.4357 28.3747 46.4272 28.764 46.4272 29.3977C47.0238 29.1853 47.5328 29.0893 47.9457 28.8381C48.9536 28.2264 49.8822 27.4814 50.9119 26.9185C51.34 26.6843 52.0613 26.5697 52.4388 26.7803C52.8197 26.991 53.1332 27.6685 53.1399 28.1472C53.1989 31.5718 53.1989 34.998 53.1399 38.4226C53.1315 38.9013 52.8163 39.5788 52.4355 39.7895C52.0579 39.9984 51.3366 39.8821 50.9085 39.6496C49.8788 39.0867 48.9468 38.3434 47.9423 37.7283C47.5446 37.4822 47.0542 37.3761 46.4255 37.1384ZM43.6953 27.955C38.2803 27.955 32.9344 27.955 27.6121 27.955C27.6121 31.5616 27.6121 35.1076 27.6121 38.635C33.0069 38.635 38.3326 38.635 43.6953 38.635C43.6953 35.0638 43.6953 31.538 43.6953 27.955ZM46.4643 34.7166C48.1395 34.1958 49.1693 35.3975 50.4215 36.0868C50.4215 34.1722 50.4215 32.374 50.4215 30.4409C49.1642 31.292 48.0805 32.3251 46.4643 31.8835C46.4643 32.8627 46.4643 33.6936 46.4643 34.7166Z"
              fill="white"
            />
            <path
              d="M14.0596 25.9969C14.2416 19.7493 19.7341 14.3967 25.9328 14.4102C26.6136 14.4119 27.2473 14.5855 27.3956 15.268C27.4917 15.7146 27.3518 16.3332 27.0788 16.6972C26.8664 16.9786 26.2917 17.0798 25.8704 17.0983C21.5778 17.2871 17.9628 20.2482 16.9937 24.4261C16.8673 24.9688 16.7999 25.5334 16.7662 26.0896C16.6921 27.3064 16.2303 27.9182 15.3539 27.8861C14.4741 27.8575 14.0242 27.2002 14.0596 25.9969Z"
              fill="white"
            />
            <path
              d="M19.4544 26.2747C19.5184 22.8535 22.5369 19.8519 25.9564 19.8098C26.8749 19.798 27.4884 20.2918 27.5356 21.0772C27.5811 21.8591 27.0148 22.4254 26.1081 22.5013C23.8009 22.6951 22.3262 24.1512 22.1475 26.4112C22.0734 27.3517 21.5577 27.9045 20.7706 27.8893C19.9516 27.8707 19.4375 27.2421 19.4544 26.2747Z"
              fill="white"
            />
            <path
              d="M39.0244 33.2878C37.6475 33.2862 37.0155 32.8783 36.9919 31.975C36.9666 31.0379 37.6273 30.5913 39.0362 30.5896C39.1761 30.5896 39.316 30.5879 39.4542 30.5896C40.4317 30.6115 41.0299 31.1289 41.0266 31.9446C41.0232 32.7586 40.4215 33.2676 39.4424 33.2878C39.3025 33.2912 39.1643 33.2878 39.0244 33.2878Z"
              fill="white"
            />
            <defs>
              <filter
                id="filter0_di_1_3950"
                x="-0.00683594"
                y="0.845703"
                width="68"
                height="68"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_1_3950"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_1_3950"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="12" dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect2_innerShadow_1_3950"
                />
              </filter>
            </defs>
          </svg>
        </Row>
      </div>
      <Modal
        setIsModalOpen={setIsModalVisible}
        closable={true}
        isModalOpen={isModalVisible}
        wideModal={true}
        pinkBg={true}
      >
        <Row className={styles.modalContentRow}>
          <Col xs={24} md={10}>
            <svg
              className={styles.svgIcon}
              viewBox="0 0 318 219"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M262.459 184.391C262.459 190.06 262.568 193.434 262.432 196.808C261.926 209.335 253.238 218.556 240.78 218.624C197.053 218.843 153.339 218.829 109.612 218.651C96.7988 218.597 87.701 209.376 87.6053 196.508C87.3868 167.602 87.3868 138.697 87.6053 109.791C87.701 96.9368 96.8125 87.7296 109.626 87.675C153.121 87.4974 196.616 87.5111 240.111 87.675C253.293 87.7296 262.09 96.9368 262.459 110.215C262.541 113.357 262.473 116.512 262.473 121.649C267.309 119.927 271.434 119.149 274.781 117.113C282.95 112.155 290.477 106.117 298.823 101.554C302.293 99.6552 308.14 98.7263 311.2 100.434C314.287 102.141 316.828 107.633 316.882 111.513C317.361 139.271 317.361 167.042 316.882 194.8C316.814 198.68 314.26 204.171 311.172 205.879C308.112 207.573 302.266 206.63 298.796 204.745C290.449 200.183 282.895 194.158 274.754 189.172C271.53 187.178 267.555 186.317 262.459 184.391ZM240.329 109.955C196.438 109.955 153.107 109.955 109.968 109.955C109.968 139.189 109.968 167.93 109.968 196.522C153.695 196.522 196.862 196.522 240.329 196.522C240.329 167.575 240.329 138.997 240.329 109.955ZM262.773 164.761C276.352 160.54 284.698 170.28 294.848 175.867C294.848 160.349 294.848 145.773 294.848 130.104C284.657 137.003 275.874 145.377 262.773 141.798C262.773 149.734 262.773 156.469 262.773 164.761Z"
                className={styles.svgIconPath}
              />
              <path
                d="M0.125085 94.0819C1.60041 43.4426 46.1199 0.056938 96.363 0.166222C101.882 0.179882 107.018 1.58691 108.22 7.1194C108.999 10.7394 107.865 15.7528 105.652 18.7035C103.931 20.9848 99.2727 21.8044 95.8576 21.9547C61.0644 23.4846 31.7627 47.4861 23.9079 81.3503C22.8834 85.749 22.337 90.3253 22.0638 94.8332C21.4627 104.696 17.7198 109.655 10.6163 109.395C3.48556 109.163 -0.161785 103.835 0.125085 94.0819Z"
                className={styles.svgIconPath}
              />
              <path
                d="M43.8548 96.3368C44.3739 68.6061 68.8398 44.2768 96.5569 43.9353C104.002 43.8396 108.974 47.8422 109.357 54.2079C109.726 60.5464 105.136 65.1363 97.7863 65.751C79.0851 67.322 67.1322 79.1246 65.6842 97.4433C65.0832 105.066 60.9031 109.546 54.5236 109.424C47.8847 109.273 43.7182 104.178 43.8548 96.3368Z"
                className={styles.svgIconPath}
              />
              <path
                d="M202.476 153.177C191.316 153.164 186.193 149.858 186.002 142.536C185.797 134.941 191.152 131.321 202.572 131.307C203.706 131.307 204.84 131.293 205.96 131.307C213.883 131.484 218.732 135.678 218.705 142.29C218.678 148.888 213.801 153.013 205.864 153.177C204.73 153.205 203.61 153.177 202.476 153.177Z"
                className={styles.svgIconPath}
              />
            </svg>
          </Col>

          <Col xs={24} md={12} lg={13}>
            <TextComponent textClass={styles.modalText1}>
            Do You Want To Join
            </TextComponent>
            <TextComponent textClass={styles.modalText2}>
            Live Streaming!!
            </TextComponent>
            <div className={styles.modalBtnContainer}>
              <SubmitButton
                title="Yes"
                btnClass={styles.modalBtn}
                // onClick={() => navigate("/rsvp/rsvplive")}
                onClick={() => onJoinStream()}
              />
              {/* sad */}
              <SubmitButton
                title="No"
                outline={true}
                btnClass={styles.modalBtn}
                onClick={() => setIsModalVisible(false)}
              />
            </div>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default RsvpGuestJoinLive;
